module.exports = __webpack_public_path__ + "img/RECEIVE_MONEY.29ba6270.svg";